import { TextFieldComponent } from "@/components/TextFieldComponent";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./PropostaFinanceira.module.css"
import { ConfirmModal } from '@/components/ConfirmModal';
import { useEffect, useState } from "react";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { CalculaDesconto } from "@/utils/calculaDesconto";
import { converterMoedaParaNumeroInteiro } from "@/utils/converterModelaParaNumero";
import { formatarMoeda } from "@/utils/formatCurrency";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { usePropostaContext } from '@/contexts/PropostaContext'
import { ActionType } from "@/contexts/PropostaContext/actions";
import { TipoPagamento } from "@/contexts/PropostaContext/types";


interface PropostaFinanceiraProps {
    propostaId: number;
    propostaFinanceiraAtivaId?: number;
}

export function PropostaFinanceira({propostaId, propostaFinanceiraAtivaId}: PropostaFinanceiraProps) {
    const {
      state: { proposta, propostaFinanceira, condicaoPagamento, propostasFinanceiras, errosPropostaFinanceira, errosCondicaoPagamento, openFormPropostaFinanceira },
      dispatch,
      acoes: {
        buscarPropostaFinanceira,
        listarPropostasFinanceiras,
        atualizarCampo,
        buscarCondicaoPagamento,
        deletarPropostaFinanceira,
      },
    } = usePropostaContext()
  
    const estadoPagamento = proposta?.estado_pagamento ?? ''

    console.log("Proposta Financeira Ativa - Valor:", propostaFinanceira?.valor_proposta);
    const valorFormatado = formatarMoeda(propostaFinanceira?.valor_proposta ?? 0);
    console.log("Valor Formatado:", valorFormatado);
    const valorEntradaFormatado = formatarMoeda(condicaoPagamento?.valor_entrada ?? 0);

    const [openConfirmDeleteFinanceira, setOpenConfirmDeleteFinanceira] = useState(false);
    const handleOpenConfirmDeleteFinanceira = () => {
        setOpenConfirmDeleteFinanceira(true);
    }
    const handleConfirmDeleteFinanceira = () => {
        if (propostaFinanceira?.id) {
            deletarPropostaFinanceira(propostaFinanceira?.id, propostaId).then(() => {
                setOpenConfirmDeleteFinanceira(false);
                dispatch({ type: ActionType.SET_FINANCEIRA, payload: null });
                dispatch({ type: ActionType.SET_CONDICAO_PAGAMENTO, payload: null });
            })
        }
    }
    const handleCloseConfirmDeleteFinanceira = () => {
        setOpenConfirmDeleteFinanceira(false);
    }

    function realizarCalculoDescontoAvista() {
        if (propostaFinanceira?.valor_proposta) {
            const valorEmDecimal = propostaFinanceira.valor_proposta
            const valor_com_desconto = CalculaDesconto(valorEmDecimal, propostaFinanceira.desconto_em_porcentagem ?? 0)

            dispatch({ type: ActionType.SET_FINANCEIRA, payload: { ...propostaFinanceira, valor_com_desconto } })
        }
    }

    function realizarCalculoDescontoEntrada() {
        if (condicaoPagamento?.valor_entrada) {
            const valorEmDecimal = condicaoPagamento.valor_entrada
            const valor_com_desconto_entrada = CalculaDesconto(valorEmDecimal, condicaoPagamento.desconto_entrada ?? 0)

            dispatch({ type: ActionType.SET_CONDICAO_PAGAMENTO, payload: { ...condicaoPagamento, valor_com_desconto_entrada } })
        }
    }

    // useEffect(() => {
    //     dispatch({ type: ActionType.SET_FINANCEIRA, payload: {...propostaFinanceira, proposta_id: propostaId, valor_proposta: propostaFinanceira?.valor_proposta ?? 0} })
    // }), [propostaId];

    useEffect(() => {
        const fetchPropostasFinanceiras = async () => {
            if (proposta?.id && proposta?.id > 0) {
                dispatch({ type: ActionType.SET_OPEN_FORM_PROPOSTA_FINANCEIRA, payload: false });
                await listarPropostasFinanceiras(proposta?.id);

                if (proposta?.PropostaFinanceiraAtivaId) {
                    buscarPropostaFinanceira(proposta?.PropostaFinanceiraAtivaId);
                }
            }
        };

        fetchPropostasFinanceiras();
    }, [proposta?.id]);

    useEffect(() => {
        if (propostaFinanceira?.id) {
            buscarCondicaoPagamento(String(propostaFinanceira.id));
        }
    }, [propostaFinanceira?.id]);

    useEffect(() => {
        realizarCalculoDescontoAvista()
    }, [propostaFinanceira?.valor_proposta, propostaFinanceira?.desconto_em_porcentagem]);

    useEffect(() => {
        realizarCalculoDescontoEntrada()
    }, [propostaFinanceira?.valor_proposta, condicaoPagamento?.valor_entrada, condicaoPagamento?.desconto_entrada]);
      
      
    return (
      <>
            {
                propostaId !== 0 && (
                    <div className={styles.container_porposta_financeira}>
                        <header className={styles.header_financeira}>
                            {propostasFinanceiras.length > 0 || openFormPropostaFinanceira ? (
                                <FormControl>
                                <InputLabel id="proposta_financeira_id" style={{ background: 'white' }}>
                                    Proposta Financeira
                                </InputLabel>
                                <Select
                                    disabled={estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                    labelId="proposta_financeira_id"
                                    value={propostaFinanceira?.id || ''}
                                    onChange={(e) => {
                                    const selecionada = propostasFinanceiras.find(pf => pf.id === Number(e.target.value));
                                    if (selecionada) {
                                        dispatch({ type: ActionType.SET_FINANCEIRA, payload: selecionada });
                                    }
                                    }}
                                    className={styles.proposta_financeira_select}
                                >
                                    <MenuItem value={0}>Selecione uma proposta financeira</MenuItem>
                                    {propostasFinanceiras.map((pf) => (
                                    <MenuItem
                                        key={pf.id}
                                        value={pf.id}
                                        style={{
                                        background:
                                            pf.id === propostaFinanceira?.id ? 'rgba(233, 119, 95, 0.5)' : '',
                                        }}
                                    >
                                        <div
                                        style={{
                                            color:
                                            pf.id === propostaFinanceiraAtivaId
                                                ? 'var(--accent-color-2)'
                                                : '',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            width: '100%',
                                        }}
                                        >
                                        <div>Prop. Financeira {pf.numero_proposta_financeira}</div>
                                        <div>
                                            {pf.id === propostaFinanceiraAtivaId && (
                                            <CheckCircleOutlineOutlinedIcon />
                                            )}
                                        </div>
                                        </div>
                                    </MenuItem>
                                    ))}
                                </Select>
                                </FormControl>
                            ) : (
                                <div className={styles.empty_component} />
                            )}

                                <div className={styles.opcoes_acoes}>
                                    <Button
                                        className={styles.add_proposta}
                                        variant="contained"
                                        onClick={() => {
                                            dispatch({
                                            type: ActionType.SET_FINANCEIRA,
                                            payload: {
                                                proposta_id: propostaId,
                                                id: undefined,
                                                valor_proposta: 0,
                                                desconto_em_porcentagem: 0,
                                                valor_com_desconto: 0,
                                                numero_proposta_financeira: undefined,
                                            },
                                            });

                                            dispatch({
                                            type: ActionType.SET_CONDICAO_PAGAMENTO,
                                            payload: {
                                                id: undefined,
                                                tipo_pagamento: 'PARCELADO',
                                                quantidade_parcela: 1,
                                                desconto_entrada: 0,
                                                valor_com_desconto_entrada: 0,
                                            },
                                            });

                                            dispatch({
                                            type: ActionType.SET_OPEN_FORM_PROPOSTA_FINANCEIRA,
                                            payload: true,
                                            });
                                        }}
                                        startIcon={<AddIcon />}
                                        disabled={estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                    >
                                        NOVA PROPOSTA FINANCEIRA
                                    </Button>

                                    {
                                        propostaFinanceira?.id && (
                                            <Button
                                                className={styles.deletar_proposta}
                                                variant="contained"
                                                startIcon={<DeleteOutlineIcon />}
                                                onClick={() => handleOpenConfirmDeleteFinanceira()}
                                                disabled={!propostaFinanceira?.id || estadoPagamento == "PAGAMENTO_CONFIRMADO"}
                                            />
                                        )
                                    }

                                </div>
                            </header>

                            
                            {(openFormPropostaFinanceira || propostasFinanceiras.length > 0) && (
                            <>
                                <Divider style={{marginBottom: '2rem', marginTop: ''}}/>
    
                                <main>
                                <div>
                                    <div className={styles.pagamento}>
                                        <div className={styles.pagamento_avista}>
                                            <span className={styles.titulo_form}>À vista</span>

                                            <div className={styles.pagamento_pix}>
                                                <div>
                                                    <TextFieldComponent
                                                        label="Valor"
                                                        name="valorAvista"
                                                        value={valorFormatado}
                                                        onChange={(e) => {
                                                            const entrada = e.target.value;
                                                            console.log("Valor inserido no campo:", entrada);
                                                            const somenteNumeros = entrada.replace(/[^\d,]/g, '');
                                                            const valorComoNumero = converterMoedaParaNumeroInteiro(somenteNumeros);
                                                            atualizarCampo('financeira', { valor_proposta: valorComoNumero, proposta_id: propostaId }, true);
                                                            
                                                            if (isNaN(valorComoNumero)) {
                                                            dispatch({
                                                                type: ActionType.SET_ERROS_FINANCEIRA,
                                                                payload: { valor_proposta: "Valor da proposta é obrigatório e deve ser numérico." },
                                                            });
                                                            } else {
                                                            dispatch({
                                                                type: ActionType.SET_ERROS_FINANCEIRA,
                                                                payload: { valor_proposta: undefined },
                                                            });
                                                            }
                                                        }}
                                                        fullWidth
                                                        width="100%"
                                                        height="3rem"
                                                        type="currency"
                                                        titleTop={true}
                                                        required={true}
                                                        disabled={estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                                    />

                                                    {errosPropostaFinanceira?.valor_proposta && (
                                                    <span className={styles.error_message}>{errosPropostaFinanceira.valor_proposta}</span>
                                                    )}
                                                </div>


                                                <TextFieldComponent
                                                    label="Desconto (%)"
                                                    name="desconto"
                                                    value={propostaFinanceira?.desconto_em_porcentagem?.toString() ?? ''}
                                                    onChange={(e) => {
                                                        const raw = e.target.value;
                                                        const somenteNumeros = raw.replace(/\D/g, '');

                                                        if (somenteNumeros === '') {
                                                        atualizarCampo('financeira', {
                                                            ...propostaFinanceira,
                                                            proposta_id: propostaId,
                                                            desconto_em_porcentagem: undefined,
                                                            valor_proposta: propostaFinanceira?.valor_proposta ?? 0
                                                        }, true);
                                                        return;
                                                        }

                                                        const valor = parseInt(somenteNumeros);

                                                        atualizarCampo('financeira', {
                                                        ...propostaFinanceira,
                                                        proposta_id: propostaId,
                                                        desconto_em_porcentagem: valor,
                                                        valor_proposta: propostaFinanceira?.valor_proposta ?? 0
                                                        }, true);

                                                        if (isNaN(valor) || valor < 0 || valor > 100) {
                                                        dispatch({
                                                            type: ActionType.SET_ERROS_FINANCEIRA,
                                                            payload: { desconto_em_porcentagem: 'Desconto deve estar entre 0 e 100' },
                                                        });
                                                        } else {
                                                        dispatch({
                                                            type: ActionType.SET_ERROS_FINANCEIRA,
                                                            payload: { desconto_em_porcentagem: undefined },
                                                        });
                                                        }
                                                    }}
                                                    fullWidth
                                                    type="text"
                                                    width="7rem"
                                                    height="3rem"
                                                    titleTop={true}
                                                    disabled={estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                                />
                                                {errosPropostaFinanceira?.desconto_em_porcentagem && (
                                                <span className={styles.error_message}>
                                                    {errosPropostaFinanceira.desconto_em_porcentagem}
                                                </span>
                                                )}

                                            </div>

                                        </div>

                                        <div className={styles.pagamento_parcelado}>
                                            <div className={styles.form_proposta_financeira_primeira_etapa}>
                                                <span className={styles.titulo_form}>Condição de Pagamento</span>
                                                <div className={styles.pagamento_credito}>
                                                    <div className={styles.primeira_linha}>
                                                        <div>
                                                            <FormControl
                                                                style={{width: "100%"}}
                                                            >
                                                                <TextField
                                                                    select
                                                                    label="Forma de Pagamento"
                                                                    value={condicaoPagamento?.tipo_pagamento ?? "PARCELADO"}
                                                                    disabled={estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                                                    onChange={(e) => {
                                                                        const novoTipoPagamento = e.target.value as TipoPagamento;
                                                                        dispatch({
                                                                        type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO,
                                                                        payload: { valor_entrada: undefined, quantidade_parcela: undefined, desconto_entrada: undefined },
                                                                        });
                                                                        atualizarCampo("condicaoPagamento", { 
                                                                            tipo_pagamento: novoTipoPagamento, 
                                                                            quantidade_parcela: condicaoPagamento?.quantidade_parcela ?? 1 
                                                                        }, true);
                                                                        }}
                                                                        className={styles.tipo_de_pagamento}
                                                                        InputProps={{
                                                                        style: {
                                                                            width: "100%",
                                                                            minWidth: "30ch",
                                                                            height: "3rem",
                                                                        },
                                                                        }}
                                                                >
                                                                    {["PARCELADO", "ENTRADA_PARCELADO"].map((item) => (
                                                                    <MenuItem key={item} value={item}>
                                                                        {item}
                                                                    </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                            </FormControl>
                                                        </div>

                                                        <FormControl
                                                            style={{width: "100%"}}
                                                        >

                                                            <TextFieldComponent
                                                                label="Parcelas"
                                                                name="quantidade_parcela"
                                                                value={condicaoPagamento?.quantidade_parcela?.toString() ?? ''}
                                                                onChange={(e) => {
                                                                    const raw = e.target.value;
                                                                    const somenteNumeros = raw.replace(/\D/g, '');

                                                                    if (somenteNumeros === '') {
                                                                    atualizarCampo('condicaoPagamento', {
                                                                        quantidade_parcela: undefined,
                                                                        tipo_pagamento: condicaoPagamento?.tipo_pagamento ?? "PARCELADO"
                                                                    }, true);
                                                                    return;
                                                                    }

                                                                    const parsed = parseInt(somenteNumeros);
                                                                    if (!isNaN(parsed)) {
                                                                    atualizarCampo('condicaoPagamento', {
                                                                        quantidade_parcela: parsed,
                                                                        tipo_pagamento: condicaoPagamento?.tipo_pagamento ?? "PARCELADO"
                                                                    }, true);

                                                                    dispatch({
                                                                        type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO,
                                                                        payload: { quantidade_parcela: undefined },
                                                                    });
                                                                    }
                                                                }}
                                                                type="text"
                                                                height="3rem"
                                                                width="100%"
                                                                minWidth="150px"
                                                                titleTop={true}
                                                                fullWidth={false}
                                                                disabled={estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                                            />


                                                            {errosCondicaoPagamento.quantidade_parcela !== undefined && (
                                                            <span className={styles.error_message}>
                                                                {errosCondicaoPagamento.quantidade_parcela}
                                                            </span>
                                                            )}


                                                        </FormControl>
                                                    </div>

                                                    <div className={styles.segunda_linha}>
                                                        <div>
                                                            <TextFieldComponent
                                                                label="Valor da Entrada"
                                                                name="valor_entrada"
                                                                value={valorEntradaFormatado}
                                                                fullWidth
                                                                width="auto"
                                                                minWidth="30ch"
                                                                height="3rem"
                                                                type="currency"
                                                                titleTop={true}
                                                                required={true}
                                                                onChange={(e) => {
                                                                    const entrada = e.target.value;
                                                                    const somenteNumeros = entrada.replace(/[^\d,]/g, '');
                                                                    const valorComoNumero = converterMoedaParaNumeroInteiro(somenteNumeros);

                                                                    atualizarCampo('condicaoPagamento', {
                                                                    ...condicaoPagamento,
                                                                    valor_entrada: valorComoNumero,
                                                                    tipo_pagamento: condicaoPagamento?.tipo_pagamento ?? "PARCELADO",
                                                                    quantidade_parcela: condicaoPagamento?.quantidade_parcela ?? 1,
                                                                    }, true);

                                                                    if (!entrada || isNaN(valorComoNumero) || valorComoNumero <= 0) {
                                                                    dispatch({
                                                                        type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO,
                                                                        payload: { valor_entrada: 'Valor de entrada é obrigatório e deve ser numérico.' },
                                                                    });
                                                                    } else {
                                                                    dispatch({
                                                                        type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO,
                                                                        payload: { valor_entrada: undefined },
                                                                    });
                                                                    }
                                                                }}
                                                                disabled={condicaoPagamento?.tipo_pagamento !== 'ENTRADA_PARCELADO' || estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                                            />

                                                            {errosCondicaoPagamento.valor_entrada !== undefined && (
                                                            <span className={styles.error_message}>{errosCondicaoPagamento.valor_entrada}</span>
                                                            )}
                                                        </div>

                                                        <div>
                                                            <TextFieldComponent
                                                                label="Desconto entrada (%)"
                                                                name="desconto_entrada"
                                                                value={condicaoPagamento?.desconto_entrada?.toString() ?? ''}
                                                                onChange={(e) => {
                                                                    const raw = e.target.value;
                                                                    const somenteNumeros = raw.replace(/\D/g, '');

                                                                    if (somenteNumeros === '') {
                                                                    atualizarCampo('condicaoPagamento', {
                                                                        ...condicaoPagamento,
                                                                        desconto_entrada: undefined,
                                                                        tipo_pagamento: condicaoPagamento?.tipo_pagamento || "PARCELADO",
                                                                        quantidade_parcela: condicaoPagamento?.quantidade_parcela || 1,
                                                                        valor_entrada: condicaoPagamento?.valor_entrada || 0,
                                                                        valor_com_desconto_entrada: condicaoPagamento?.valor_com_desconto_entrada || 0,
                                                                    }, true);

                                                                    return;
                                                                    }

                                                                    const parsed = parseInt(somenteNumeros);

                                                                    atualizarCampo('condicaoPagamento', {
                                                                    ...condicaoPagamento,
                                                                    desconto_entrada: parsed,
                                                                    tipo_pagamento: condicaoPagamento?.tipo_pagamento || "PARCELADO",
                                                                    quantidade_parcela: condicaoPagamento?.quantidade_parcela || 1,
                                                                    valor_entrada: condicaoPagamento?.valor_entrada || 0,
                                                                    valor_com_desconto_entrada: condicaoPagamento?.valor_com_desconto_entrada || 0,
                                                                    }, true);

                                                                    if (isNaN(parsed) || parsed < 0 || parsed > 100) {
                                                                    dispatch({
                                                                        type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO,
                                                                        payload: { desconto_entrada: 'Desconto deve estar entre 0 e 100%' },
                                                                    });
                                                                    } else {
                                                                    dispatch({
                                                                        type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO,
                                                                        payload: { desconto_entrada: undefined },
                                                                    });
                                                                    }
                                                                }}
                                                                fullWidth
                                                                width="100%"
                                                                height="3rem"
                                                                type="text"
                                                                titleTop={true}
                                                                disabled={condicaoPagamento?.tipo_pagamento !== 'ENTRADA_PARCELADO' || estadoPagamento === 'PAGAMENTO_CONFIRMADO'}
                                                            />
                                                            {errosCondicaoPagamento.desconto_entrada !== undefined && (
                                                                <span className={styles.error_message}>{errosCondicaoPagamento.desconto_entrada}</span>
                                                            )}
                                                        </div>
                                                        

                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        
                                    </div>


                                    <div className={styles.form_proposta_financeira_segunda_etapa}>
                                        {
                                            (propostaFinanceira?.valor_proposta || condicaoPagamento?.quantidade_parcela && condicaoPagamento?.quantidade_parcela > 0) ?
                                            (
                                                <>
                                                    <Divider component="li" style={{ listStyle: 'none' }} />
                                                    {
                                                        propostaFinanceira?.valor_com_desconto &&
                                                        propostaFinanceira?.valor_com_desconto > 0 &&
                                                        propostaFinanceira?.valor_proposta > 0 && (
                                                            <span className={styles.valor_total_avista}>
                                                                Valor à vista com desconto aplicado: {formatarMoeda(Number(propostaFinanceira?.valor_com_desconto) || 0)}
                                                            </span>
                                                        ) ||
                                                        <span className={styles.valor_total_avista}>
                                                            Valor total à vista: {formatarMoeda(Number(propostaFinanceira?.valor_proposta) || 0)}
                                                        </span>
                                                    }

                                                    {
                                                        condicaoPagamento?.tipo_pagamento === 'ENTRADA_PARCELADO' &&
                                                        <span className={styles.valor_desconto}>
                                                            Valor da entrada com desconto aplicado: {formatarMoeda(CalculaDesconto(converterMoedaParaNumeroInteiro(String(condicaoPagamento?.valor_entrada ?? 0)), condicaoPagamento?.desconto_entrada ?? 0))}
                                                        </span>
                                                    }

                                                    {
                                                        condicaoPagamento?.quantidade_parcela &&
                                                        condicaoPagamento.quantidade_parcela >= 1 &&
                                                        propostaFinanceira?.valor_proposta &&
                                                        propostaFinanceira?.valor_proposta > 0 && (
                                                            <span className={styles.valor_parcelado}>
                                                            Parcelas: {condicaoPagamento.quantidade_parcela}x no valor de {
                                                                (() => {
                                                                const parcelas = condicaoPagamento.quantidade_parcela;
                                                                const valorProposta = Number(propostaFinanceira?.valor_proposta ?? 0);
                                                                const valorEntrada = Number(condicaoPagamento?.valor_entrada ?? 0);

                                                                const valor =
                                                                    condicaoPagamento.tipo_pagamento === 'ENTRADA_PARCELADO'
                                                                    ? (valorProposta - valorEntrada) / parcelas
                                                                    : valorProposta / parcelas;

                                                                return formatarMoeda(valor);
                                                                })()
                                                            }
                                                            </span>
                                                        ) ||
                                                        <div></div>
                                                    }

                                                </>
                                            ) : <></>
                                        }
                                    </div>
                                    
                                </div>
                            </main >
                            </>
                        )}


                        
                    </div>
                )
            }

            <ConfirmModal
                open={openConfirmDeleteFinanceira}
                onClose={handleCloseConfirmDeleteFinanceira}
                onConfirm={handleConfirmDeleteFinanceira}
                title="Confirmar exclusão"
                description="Você tem certeza que deseja excluir esta proposta financeira?"
                confirmText="Confirmar"
                cancelText="Cancelar"
                confirmButtonStyle={{
                    color: '#F7F7F9',
                    backgroundColor: 'var(--primary-color)',
                    '&:hover': { backgroundColor: 'var(--primary-color-dark)' }
                }}
                cancelButtonStyle={{
                    color: 'var(--text)',
                    backgroundColor: 'var(--border-color-2)',
                    '&:hover': { backgroundColor: '#aaaaaa' }
                }}
            />
      </>
    )
  }